// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.StoreVerify_container__K47HW {
  padding: 20px;
  max-width: 100%;
  overflow-x: auto;
  min-height: 100vh;
}

.StoreVerify_header__un3Vm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.StoreVerify_headerLeft__n0IwR h2 {
  margin: 0 0 5px 0;
  font-size: 1.8rem;
  font-weight: 600;
}

.StoreVerify_headerLeft__n0IwR p {
  margin: 0;
  opacity: 0.9;
  font-size: 0.9rem;
}

.StoreVerify_headerRight__cP\\+0y {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.StoreVerify_refreshBtn__MTF0V, .StoreVerify_printBtn__mkmqh, .StoreVerify_excelBtn__Dvh0D, .StoreVerify_deleteBtn__XaaH\\+ {
  padding: 10px 15px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}

.StoreVerify_refreshBtn__MTF0V {
  background: #3498db;
  color: white;
}
.StoreVerify_refreshBtn__MTF0V:hover:not(:disabled) {
  background: #2980b9;
  transform: translateY(-1px);
}
.StoreVerify_refreshBtn__MTF0V:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
}

.StoreVerify_printBtn__mkmqh {
  background: #e74c3c;
  color: white;
}
.StoreVerify_printBtn__mkmqh:hover {
  background: #c0392b;
  transform: translateY(-1px);
}

.StoreVerify_excelBtn__Dvh0D {
  background: #27ae60;
  color: white;
}
.StoreVerify_excelBtn__Dvh0D:hover {
  background: #229954;
  transform: translateY(-1px);
}

.StoreVerify_deleteBtn__XaaH\\+ {
  background: #e67e22;
  color: white;
}
.StoreVerify_deleteBtn__XaaH\\+:hover {
  background: #d35400;
  transform: translateY(-1px);
}

.StoreVerify_globalSearch__tpJX0 {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.StoreVerify_searchInput__UyQqY {
  flex: 1 1;
  min-width: 300px;
  padding: 12px 15px;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}
.StoreVerify_searchInput__UyQqY:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.StoreVerify_filterToggle__NAzFn, .StoreVerify_clearFilters__xqXfS {
  padding: 12px 15px;
  border: 2px solid #ddd;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}
.StoreVerify_filterToggle__NAzFn:hover, .StoreVerify_clearFilters__xqXfS:hover {
  border-color: #667eea;
  background: #f8f9ff;
}

.StoreVerify_clearFilters__xqXfS {
  background: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}
.StoreVerify_clearFilters__xqXfS:hover {
  background: #f1b0b7;
  border-color: #ed969e;
}

.StoreVerify_filtersPanel__GDnB8 {
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.StoreVerify_filtersGrid__iS7qL {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}

.StoreVerify_filterGroup__v8BhU {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.StoreVerify_filterGroup__v8BhU label {
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
}
.StoreVerify_filterGroup__v8BhU input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
}
.StoreVerify_filterGroup__v8BhU input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.StoreVerify_tableContainer__JA967 {
  background: white;
  border-radius: 8px;
  overflow-x: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  position: relative;
}
.StoreVerify_tableContainer__JA967::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 20px;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.8));
  pointer-events: none;
  z-index: 1;
}

.StoreVerify_dataTable__Ky2rh {
  width: 100%;
  min-width: 2400px;
  border-collapse: collapse;
  font-size: 0.85rem;
}
.StoreVerify_dataTable__Ky2rh th, .StoreVerify_dataTable__Ky2rh td {
  padding: 12px 8px;
  text-align: center;
  border: 1px solid #ddd;
  vertical-align: middle;
  white-space: nowrap;
  min-width: 80px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(1), .StoreVerify_dataTable__Ky2rh td:nth-child(1) {
  min-width: 100px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(2), .StoreVerify_dataTable__Ky2rh td:nth-child(2) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(3), .StoreVerify_dataTable__Ky2rh td:nth-child(3) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(4), .StoreVerify_dataTable__Ky2rh td:nth-child(4) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(5), .StoreVerify_dataTable__Ky2rh td:nth-child(5) {
  min-width: 100px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(6), .StoreVerify_dataTable__Ky2rh td:nth-child(6) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(7), .StoreVerify_dataTable__Ky2rh td:nth-child(7) {
  min-width: 150px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(8), .StoreVerify_dataTable__Ky2rh td:nth-child(8) {
  min-width: 80px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(9), .StoreVerify_dataTable__Ky2rh td:nth-child(9) {
  min-width: 100px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(10), .StoreVerify_dataTable__Ky2rh td:nth-child(10) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(11), .StoreVerify_dataTable__Ky2rh td:nth-child(11) {
  min-width: 80px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(12), .StoreVerify_dataTable__Ky2rh td:nth-child(12) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(13), .StoreVerify_dataTable__Ky2rh td:nth-child(13) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(14), .StoreVerify_dataTable__Ky2rh td:nth-child(14) {
  min-width: 80px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(15), .StoreVerify_dataTable__Ky2rh td:nth-child(15) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(16), .StoreVerify_dataTable__Ky2rh td:nth-child(16) {
  min-width: 80px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(17), .StoreVerify_dataTable__Ky2rh td:nth-child(17) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(18), .StoreVerify_dataTable__Ky2rh td:nth-child(18) {
  min-width: 100px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(19), .StoreVerify_dataTable__Ky2rh td:nth-child(19) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(20), .StoreVerify_dataTable__Ky2rh td:nth-child(20) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(21), .StoreVerify_dataTable__Ky2rh td:nth-child(21) {
  min-width: 80px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(22), .StoreVerify_dataTable__Ky2rh td:nth-child(22) {
  min-width: 120px;
}
.StoreVerify_dataTable__Ky2rh th:nth-child(23), .StoreVerify_dataTable__Ky2rh td:nth-child(23) {
  min-width: 80px;
}
.StoreVerify_dataTable__Ky2rh .StoreVerify_mainHeader__JT9AO {
  background-color: #4a5568;
  color: white;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 10;
  height: 50px;
}
.StoreVerify_dataTable__Ky2rh .StoreVerify_subHeader__J1k25 {
  background-color: #e2e8f0;
  font-weight: bold;
  position: sticky;
  top: 50px;
  z-index: 9;
  height: 50px;
}
.StoreVerify_dataTable__Ky2rh .StoreVerify_columnNumbers__4RuHu {
  background-color: #90EE90;
  font-weight: bold;
  position: sticky;
  top: 100px;
  z-index: 8;
  height: 40px;
}
.StoreVerify_dataTable__Ky2rh .StoreVerify_dataRow__ABvdH:nth-child(even) {
  background-color: #90EE90;
}
.StoreVerify_dataTable__Ky2rh .StoreVerify_dataRow__ABvdH:nth-child(odd) {
  background-color: white;
}
.StoreVerify_dataTable__Ky2rh .StoreVerify_dataRow__ABvdH:hover {
  background-color: #f8f9ff;
}
.StoreVerify_dataTable__Ky2rh .StoreVerify_noData__cHnFQ {
  text-align: center;
  padding: 20px;
  color: #666;
  font-style: italic;
}

.StoreVerify_clickableField__MwmUA {
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}
.StoreVerify_clickableField__MwmUA:hover {
  background-color: #e3f2fd;
  color: #1976d2;
  font-weight: 500;
}
.StoreVerify_clickableField__MwmUA:hover::after {
  content: "👁️";
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8rem;
}

.StoreVerify_depreciationValue__W-FPO {
  font-weight: 600;
  color: #27ae60;
  background: #d5f4e6;
  border-radius: 4px;
  padding: 4px 8px;
  text-align: center;
}

.StoreVerify_depreciationAmount__N4PM3 {
  font-weight: 600;
  color: #e74c3c;
  background: #fadbd8;
  border-radius: 4px;
  padding: 4px 8px;
  text-align: center;
}

.StoreVerify_depreciationInputGroup__sAWb3 {
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;
}

.StoreVerify_depreciationInput__cT6t5 {
  width: 100%;
  padding: 4px 6px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 0.8rem;
  text-align: center;
  background: white;
}
.StoreVerify_depreciationInput__cT6t5:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}
.StoreVerify_depreciationInput__cT6t5::placeholder {
  color: #999;
  font-style: italic;
}

.StoreVerify_manualIndicator__Rs5JA {
  font-size: 0.7rem;
  color: #667eea;
  position: absolute;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.StoreVerify_resetBtn__uyOdA {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 2px;
  border-radius: 3px;
  transition: all 0.2s ease;
}
.StoreVerify_resetBtn__uyOdA:hover {
  background: #f8f9fa;
  transform: scale(1.1);
}

.StoreVerify_verifyBtn__TWdQa {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
  min-width: 40px;
}
.StoreVerify_verifyBtn__TWdQa.StoreVerify_verified__kExIH {
  background: #d5f4e6;
  color: #27ae60;
}
.StoreVerify_verifyBtn__TWdQa.StoreVerify_verified__kExIH:hover {
  background: #a8e6cf;
  transform: scale(1.05);
}
.StoreVerify_verifyBtn__TWdQa.StoreVerify_unverified__-47ze {
  background: #fadbd8;
  color: #e74c3c;
}
.StoreVerify_verifyBtn__TWdQa.StoreVerify_unverified__-47ze:hover {
  background: #f1948a;
  transform: scale(1.05);
}

.StoreVerify_commentInput__ohmJp {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.8rem;
}
.StoreVerify_commentInput__ohmJp:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.StoreVerify_viewDetailsBtn__H9W-o {
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background: #3498db;
  color: white;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}
.StoreVerify_viewDetailsBtn__H9W-o:hover {
  background: #2980b9;
  transform: scale(1.05);
}

.StoreVerify_pagination__L0XsV {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.StoreVerify_paginationInfo__0zE1h {
  display: flex;
  align-items: center;
  gap: 15px;
  color: #666;
  font-size: 0.9rem;
}

.StoreVerify_itemsPerPage__9k5M1 {
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
}

.StoreVerify_paginationControls__84Z0E {
  display: flex;
  gap: 5px;
  align-items: center;
}

.StoreVerify_pageBtn__NWpnF {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.StoreVerify_pageBtn__NWpnF:hover:not(:disabled) {
  background: #667eea;
  color: white;
  border-color: #667eea;
}
.StoreVerify_pageBtn__NWpnF.StoreVerify_activePage__N1m9r {
  background: #667eea;
  color: white;
  border-color: #667eea;
}
.StoreVerify_pageBtn__NWpnF.StoreVerify_disabled__YzEO- {
  color: #ccc;
  cursor: not-allowed;
}

.StoreVerify_loading__YtjWH, .StoreVerify_error__deRcn {
  text-align: center;
  padding: 40px;
  font-size: 1.2rem;
  color: #666;
}

.StoreVerify_error__deRcn {
  color: #e74c3c;
}

.StoreVerify_modalOverlay__4\\+yz\\+ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.StoreVerify_verificationModal__KDMMS {
  background: white;
  border-radius: 10px;
  padding: 30px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.StoreVerify_verificationModal__KDMMS h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 1.5rem;
}

.StoreVerify_verificationModal__KDMMS p {
  margin: 0 0 20px 0;
  color: #666;
}

.StoreVerify_allFields__a2P5n, .StoreVerify_singleField__Klh2i {
  margin: 20px 0;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #667eea;
}

.StoreVerify_fieldRow__-0iZ9 {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}
.StoreVerify_fieldRow__-0iZ9:last-child {
  border-bottom: none;
}
.StoreVerify_fieldRow__-0iZ9 label {
  font-weight: 600;
  color: #333;
  min-width: 150px;
}
.StoreVerify_fieldRow__-0iZ9 span {
  color: #666;
  text-align: right;
  flex: 1 1;
}

.StoreVerify_singleField__Klh2i label {
  display: block;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}
.StoreVerify_singleField__Klh2i span {
  display: block;
  color: #666;
  padding: 10px;
  background: white;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.StoreVerify_verificationActions__WaAO3 {
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.StoreVerify_modalButtons__-79GP {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.StoreVerify_closeBtn__WLB3S {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  background: #6c757d;
  color: white;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}
.StoreVerify_closeBtn__WLB3S:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

.StoreVerify_modal__3uKSA {
  background: white;
  border-radius: 10px;
  padding: 30px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.StoreVerify_modal__3uKSA h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 1.5rem;
}

.StoreVerify_modal__3uKSA p {
  margin: 0 0 20px 0;
  color: #666;
}

.StoreVerify_passwordInput__nrkyH {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
  margin-bottom: 15px;
}
.StoreVerify_passwordInput__nrkyH:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.StoreVerify_modalButtons__-79GP {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.StoreVerify_deleteConfirmBtn__UmlEZ {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  background: #dc3545;
  color: white;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}
.StoreVerify_deleteConfirmBtn__UmlEZ:hover:not(:disabled) {
  background: #c82333;
  transform: translateY(-1px);
}
.StoreVerify_deleteConfirmBtn__UmlEZ:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.StoreVerify_cancelBtn__\\+x13R {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  background: #6c757d;
  color: white;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}
.StoreVerify_cancelBtn__\\+x13R:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

@media (max-width: 1200px) {
  .StoreVerify_container__K47HW {
    padding: 15px;
  }
  .StoreVerify_header__un3Vm {
    padding: 15px;
  }
  .StoreVerify_headerLeft__n0IwR h2 {
    font-size: 1.5rem;
  }
  .StoreVerify_dataTable__Ky2rh {
    font-size: 0.8rem;
  }
  .StoreVerify_dataTable__Ky2rh th, .StoreVerify_dataTable__Ky2rh td {
    padding: 10px 6px;
  }
}
@media (max-width: 768px) {
  .StoreVerify_container__K47HW {
    padding: 10px;
  }
  .StoreVerify_header__un3Vm {
    flex-direction: column;
    gap: 15px;
    text-align: center;
    padding: 15px;
  }
  .StoreVerify_headerLeft__n0IwR h2 {
    font-size: 1.3rem;
  }
  .StoreVerify_headerRight__cP\\+0y {
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .StoreVerify_refreshBtn__MTF0V, .StoreVerify_printBtn__mkmqh, .StoreVerify_excelBtn__Dvh0D, .StoreVerify_deleteBtn__XaaH\\+ {
    padding: 8px 12px;
    font-size: 0.9rem;
  }
  .StoreVerify_globalSearch__tpJX0 {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .StoreVerify_searchInput__UyQqY {
    min-width: auto;
    padding: 10px 12px;
  }
  .StoreVerify_filterToggle__NAzFn, .StoreVerify_clearFilters__xqXfS {
    padding: 10px 12px;
  }
  .StoreVerify_filtersGrid__iS7qL {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .StoreVerify_filterGroup__v8BhU input {
    padding: 6px 10px;
  }
  .StoreVerify_dataTable__Ky2rh {
    font-size: 0.75rem;
    min-width: 2200px;
  }
  .StoreVerify_dataTable__Ky2rh th, .StoreVerify_dataTable__Ky2rh td {
    padding: 8px 4px;
    min-width: 70px;
  }
  .StoreVerify_pagination__L0XsV {
    flex-direction: column;
    gap: 15px;
    padding: 15px;
  }
  .StoreVerify_paginationControls__84Z0E {
    flex-wrap: wrap;
    justify-content: center;
  }
  .StoreVerify_pageBtn__NWpnF {
    padding: 6px 10px;
    font-size: 0.9rem;
  }
  .StoreVerify_verificationModal__KDMMS {
    width: 95%;
    padding: 20px;
    max-height: 90vh;
  }
  .StoreVerify_modal__3uKSA {
    width: 95%;
    padding: 20px;
  }
}
@media (max-width: 480px) {
  .StoreVerify_container__K47HW {
    padding: 5px;
  }
  .StoreVerify_header__un3Vm {
    padding: 10px;
  }
  .StoreVerify_headerLeft__n0IwR h2 {
    font-size: 1.2rem;
  }
  .StoreVerify_dataTable__Ky2rh {
    font-size: 0.7rem;
    min-width: 2000px;
  }
  .StoreVerify_dataTable__Ky2rh th, .StoreVerify_dataTable__Ky2rh td {
    padding: 6px 3px;
    min-width: 60px;
  }
  .StoreVerify_verifyBtn__TWdQa {
    padding: 4px 8px;
    font-size: 0.9rem;
    min-width: 35px;
  }
  .StoreVerify_commentInput__ohmJp {
    padding: 4px 6px;
    font-size: 0.75rem;
  }
  .StoreVerify_viewDetailsBtn__H9W-o {
    padding: 4px 8px;
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/store-verify/StoreVerify.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;AAEF;;AACA;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;AAEF;;AACA;EACE,SAAA;EACA,YAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAEF;;AACA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAEF;;AACA;EACE,mBAAA;EACA,YAAA;AAEF;AAAE;EACE,mBAAA;EACA,2BAAA;AAEJ;AACE;EACE,mBAAA;EACA,mBAAA;AACJ;;AAGA;EACE,mBAAA;EACA,YAAA;AAAF;AAEE;EACE,mBAAA;EACA,2BAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,YAAA;AADF;AAGE;EACE,mBAAA;EACA,2BAAA;AADJ;;AAKA;EACE,mBAAA;EACA,YAAA;AAFF;AAIE;EACE,mBAAA;EACA,2BAAA;AAFJ;;AAMA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAHF;;AAMA;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AAHF;AAKE;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAJF;AAME;EACE,qBAAA;EACA,mBAAA;AAJJ;;AAQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AALF;AAOE;EACE,mBAAA;EACA,qBAAA;AALJ;;AASA;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;AANF;;AASA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AANF;AAQE;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AANJ;AASE;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AAPJ;AASI;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAPN;;AAYA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,kBAAA;AATF;AAYE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,4EAAA;EACA,oBAAA;EACA,UAAA;AAVJ;;AAcA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAXF;AAaE;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAXJ;AAeE;EAAmC,gBAAA;AAZrC;AAaE;EAAmC,gBAAA;AAVrC;AAWE;EAAmC,gBAAA;AARrC;AASE;EAAmC,gBAAA;AANrC;AAOE;EAAmC,gBAAA;AAJrC;AAKE;EAAmC,gBAAA;AAFrC;AAGE;EAAmC,gBAAA;AAArC;AACE;EAAmC,eAAA;AAErC;AADE;EAAmC,gBAAA;AAIrC;AAHE;EAAqC,gBAAA;AAMvC;AALE;EAAqC,eAAA;AAQvC;AAPE;EAAqC,gBAAA;AAUvC;AATE;EAAqC,gBAAA;AAYvC;AAXE;EAAqC,eAAA;AAcvC;AAbE;EAAqC,gBAAA;AAgBvC;AAfE;EAAqC,eAAA;AAkBvC;AAjBE;EAAqC,gBAAA;AAoBvC;AAnBE;EAAqC,gBAAA;AAsBvC;AArBE;EAAqC,gBAAA;AAwBvC;AAvBE;EAAqC,gBAAA;AA0BvC;AAzBE;EAAqC,eAAA;AA4BvC;AA3BE;EAAqC,gBAAA;AA8BvC;AA7BE;EAAqC,eAAA;AAgCvC;AA9BE;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AAgCJ;AA7BE;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA+BJ;AA5BE;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;AA8BJ;AA3BE;EACE,yBAAA;AA6BJ;AA1BE;EACE,uBAAA;AA4BJ;AAzBE;EACE,yBAAA;AA2BJ;AAxBE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AA0BJ;;AAtBA;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;AAyBF;AAvBE;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AAyBJ;AAvBI;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;AAyBN;;AApBA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAuBF;;AApBA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAuBF;;AApBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAuBF;;AApBA;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAuBF;AArBE;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAuBJ;AApBE;EACE,WAAA;EACA,kBAAA;AAsBJ;;AAlBA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;AAqBF;;AAlBA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAqBF;AAnBE;EACE,mBAAA;EACA,qBAAA;AAqBJ;;AAjBA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAoBF;AAlBE;EACE,mBAAA;EACA,cAAA;AAoBJ;AAlBI;EACE,mBAAA;EACA,sBAAA;AAoBN;AAhBE;EACE,mBAAA;EACA,cAAA;AAkBJ;AAhBI;EACE,mBAAA;EACA,sBAAA;AAkBN;;AAbA;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AAgBF;AAdE;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAgBJ;;AAZA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AAeF;AAbE;EACE,mBAAA;EACA,sBAAA;AAeJ;;AAXA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;AAcF;;AAXA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;AAcF;;AAXA;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AAcF;;AAXA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAcF;;AAXA;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAcF;AAZE;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AAcJ;AAXE;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AAaJ;AAVE;EACE,WAAA;EACA,mBAAA;AAYJ;;AARA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;AAWF;;AARA;EACE,cAAA;AAWF;;AARA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAWF;;AARA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;AAWF;;AARA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;AAWF;;AARA;EACE,kBAAA;EACA,WAAA;AAWF;;AARA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AAWF;;AARA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,6BAAA;AAWF;AATE;EACE,mBAAA;AAWJ;AARE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AAUJ;AAPE;EACE,WAAA;EACA,iBAAA;EACA,SAAA;AASJ;;AAJE;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAOJ;AAJE;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAMJ;;AAFA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAKF;;AAFA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AAKF;;AAFA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAKF;AAHE;EACE,mBAAA;EACA,2BAAA;AAKJ;;AADA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,0CAAA;AAIF;;AADA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;AAIF;;AADA;EACE,kBAAA;EACA,WAAA;AAIF;;AADA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAIF;AAFE;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAIJ;;AAAA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAGF;;AAAA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAGF;AADE;EACE,mBAAA;EACA,2BAAA;AAGJ;AAAE;EACE,mBAAA;EACA,mBAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AACF;AACE;EACE,mBAAA;EACA,2BAAA;AACJ;;AAIA;EACE;IACE,aAAA;EADF;EAIA;IACE,aAAA;EAFF;EAKA;IACE,iBAAA;EAHF;EAMA;IACE,iBAAA;EAJF;EAME;IACE,iBAAA;EAJJ;AACF;AAQA;EACE;IACE,aAAA;EANF;EASA;IACE,sBAAA;IACA,SAAA;IACA,kBAAA;IACA,aAAA;EAPF;EAUA;IACE,iBAAA;EARF;EAWA;IACE,uBAAA;IACA,eAAA;IACA,QAAA;EATF;EAYA;IACE,iBAAA;IACA,iBAAA;EAVF;EAaA;IACE,sBAAA;IACA,oBAAA;IACA,QAAA;EAXF;EAcA;IACE,eAAA;IACA,kBAAA;EAZF;EAeA;IACE,kBAAA;EAbF;EAgBA;IACE,0BAAA;IACA,SAAA;EAdF;EAiBA;IACE,iBAAA;EAfF;EAkBA;IACE,kBAAA;IACA,iBAAA;EAhBF;EAkBE;IACE,gBAAA;IACA,eAAA;EAhBJ;EAoBA;IACE,sBAAA;IACA,SAAA;IACA,aAAA;EAlBF;EAqBA;IACE,eAAA;IACA,uBAAA;EAnBF;EAsBA;IACE,iBAAA;IACA,iBAAA;EApBF;EAuBA;IACE,UAAA;IACA,aAAA;IACA,gBAAA;EArBF;EAwBA;IACE,UAAA;IACA,aAAA;EAtBF;AACF;AAyBA;EACE;IACE,YAAA;EAvBF;EA0BA;IACE,aAAA;EAxBF;EA2BA;IACE,iBAAA;EAzBF;EA4BA;IACE,iBAAA;IACA,iBAAA;EA1BF;EA4BE;IACE,gBAAA;IACA,eAAA;EA1BJ;EA8BA;IACE,gBAAA;IACA,iBAAA;IACA,eAAA;EA5BF;EA+BA;IACE,gBAAA;IACA,kBAAA;EA7BF;EAgCA;IACE,gBAAA;IACA,iBAAA;EA9BF;AACF","sourcesContent":[".container {\n  padding: 20px;\n  max-width: 100%;\n  overflow-x: auto;\n  min-height: 100vh;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding: 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 10px;\n  color: white;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.headerLeft h2 {\n  margin: 0 0 5px 0;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.headerLeft p {\n  margin: 0;\n  opacity: 0.9;\n  font-size: 0.9rem;\n}\n\n.headerRight {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.refreshBtn, .printBtn, .excelBtn, .deleteBtn {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.refreshBtn {\n  background: #3498db;\n  color: white;\n  \n  &:hover:not(:disabled) {\n    background: #2980b9;\n    transform: translateY(-1px);\n  }\n  \n  &:disabled {\n    background: #bdc3c7;\n    cursor: not-allowed;\n  }\n}\n\n.printBtn {\n  background: #e74c3c;\n  color: white;\n  \n  &:hover {\n    background: #c0392b;\n    transform: translateY(-1px);\n  }\n}\n\n.excelBtn {\n  background: #27ae60;\n  color: white;\n  \n  &:hover {\n    background: #229954;\n    transform: translateY(-1px);\n  }\n}\n\n.deleteBtn {\n  background: #e67e22;\n  color: white;\n  \n  &:hover {\n    background: #d35400;\n    transform: translateY(-1px);\n  }\n}\n\n.globalSearch {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.searchInput {\n  flex: 1;\n  min-width: 300px;\n  padding: 12px 15px;\n  border: 2px solid #ddd;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n  \n  &:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n  }\n}\n\n.filterToggle, .clearFilters {\n  padding: 12px 15px;\n  border: 2px solid #ddd;\n  background: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  \n  &:hover {\n    border-color: #667eea;\n    background: #f8f9ff;\n  }\n}\n\n.clearFilters {\n  background: #f8d7da;\n  border-color: #f5c6cb;\n  color: #721c24;\n  \n  &:hover {\n    background: #f1b0b7;\n    border-color: #ed969e;\n  }\n}\n\n.filtersPanel {\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.filtersGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 15px;\n}\n\n.filterGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  \n  label {\n    font-weight: 500;\n    color: #333;\n    font-size: 0.9rem;\n  }\n  \n  input {\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 0.9rem;\n    \n    &:focus {\n      outline: none;\n      border-color: #667eea;\n      box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n    }\n  }\n}\n\n.tableContainer {\n  background: white;\n  border-radius: 8px;\n  overflow-x: auto;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n  position: relative;\n  \n  // Add horizontal scroll indicator\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 20px;\n    background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.8));\n    pointer-events: none;\n    z-index: 1;\n  }\n}\n\n.dataTable {\n  width: 100%;\n  min-width: 2400px; // Ensure minimum width for all columns (increased for new depreciation columns)\n  border-collapse: collapse;\n  font-size: 0.85rem;\n  \n  th, td {\n    padding: 12px 8px;\n    text-align: center;\n    border: 1px solid #ddd;\n    vertical-align: middle;\n    white-space: nowrap; // Prevent text wrapping\n    min-width: 80px; // Minimum column width\n  }\n  \n  // Specific column widths for better layout\n  th:nth-child(1), td:nth-child(1) { min-width: 100px; } // मिति\n  th:nth-child(2), td:nth-child(2) { min-width: 120px; } // दाखिला नं\n  th:nth-child(3), td:nth-child(3) { min-width: 120px; } // स्पेसिफिकेसन\n  th:nth-child(4), td:nth-child(4) { min-width: 120px; } // सामानको पहिचान\n  th:nth-child(5), td:nth-child(5) { min-width: 100px; } // मोडल नं\n  th:nth-child(6), td:nth-child(6) { min-width: 120px; } // जिन्सी सामानको नाम\n  th:nth-child(7), td:nth-child(7) { min-width: 150px; } // उत्पादन गर्ने देश\n  th:nth-child(8), td:nth-child(8) { min-width: 80px; }  // साइज\n  th:nth-child(9), td:nth-child(9) { min-width: 100px; } // अनुमानित आयु\n  th:nth-child(10), td:nth-child(10) { min-width: 120px; } // सामान प्राप्तिको स्रोत\n  th:nth-child(11), td:nth-child(11) { min-width: 80px; }  // परिमाण\n  th:nth-child(12), td:nth-child(12) { min-width: 120px; } // प्रति एकाइको दर\n  th:nth-child(13), td:nth-child(13) { min-width: 120px; } // जम्मा परल मूल्य\n  th:nth-child(14), td:nth-child(14) { min-width: 80px; }  // परिमाण\n  th:nth-child(15), td:nth-child(15) { min-width: 120px; } // जम्मा परल मूल्य\n  th:nth-child(16), td:nth-child(16) { min-width: 80px; }  // परिमाण\n  th:nth-child(17), td:nth-child(17) { min-width: 120px; } // जम्मा परल मूल्य\n  th:nth-child(18), td:nth-child(18) { min-width: 100px; } // कैफियत\n  th:nth-child(19), td:nth-child(19) { min-width: 120px; } // मूल्यह्रास रकम\n  th:nth-child(20), td:nth-child(20) { min-width: 120px; } // वर्तमान मूल्य\n  th:nth-child(21), td:nth-child(21) { min-width: 80px; }  // सत्यापित\n  th:nth-child(22), td:nth-child(22) { min-width: 120px; } // टिप्पणी\n  th:nth-child(23), td:nth-child(23) { min-width: 80px; }  // कार्य\n  \n  .mainHeader {\n    background-color: #4a5568;\n    color: white;\n    font-weight: bold;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    height: 50px; // Fixed height to prevent overlap\n  }\n  \n  .subHeader {\n    background-color: #e2e8f0;\n    font-weight: bold;\n    position: sticky;\n    top: 50px; // Exact height of mainHeader\n    z-index: 9;\n    height: 50px; // Fixed height to prevent overlap\n  }\n  \n  .columnNumbers {\n    background-color: #90EE90;\n    font-weight: bold;\n    position: sticky;\n    top: 100px; // Exact height of mainHeader + subHeader\n    z-index: 8;\n    height: 40px; // Fixed height to prevent overlap\n  }\n  \n  .dataRow:nth-child(even) {\n    background-color: #90EE90;\n  }\n  \n  .dataRow:nth-child(odd) {\n    background-color: white;\n  }\n  \n  .dataRow:hover {\n    background-color: #f8f9ff;\n  }\n  \n  .noData {\n    text-align: center;\n    padding: 20px;\n    color: #666;\n    font-style: italic;\n  }\n}\n\n.clickableField {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  \n  &:hover {\n    background-color: #e3f2fd;\n    color: #1976d2;\n    font-weight: 500;\n    \n    &::after {\n      content: '👁️';\n      position: absolute;\n      right: 5px;\n      top: 50%;\n      transform: translateY(-50%);\n      font-size: 0.8rem;\n    }\n  }\n}\n\n.depreciationValue {\n  font-weight: 600;\n  color: #27ae60;\n  background: #d5f4e6;\n  border-radius: 4px;\n  padding: 4px 8px;\n  text-align: center;\n}\n\n.depreciationAmount {\n  font-weight: 600;\n  color: #e74c3c;\n  background: #fadbd8;\n  border-radius: 4px;\n  padding: 4px 8px;\n  text-align: center;\n}\n\n.depreciationInputGroup {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  position: relative;\n}\n\n.depreciationInput {\n  width: 100%;\n  padding: 4px 6px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-size: 0.8rem;\n  text-align: center;\n  background: white;\n  \n  &:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n  }\n  \n  &::placeholder {\n    color: #999;\n    font-style: italic;\n  }\n}\n\n.manualIndicator {\n  font-size: 0.7rem;\n  color: #667eea;\n  position: absolute;\n  right: 2px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.resetBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.8rem;\n  padding: 2px;\n  border-radius: 3px;\n  transition: all 0.2s ease;\n  \n  &:hover {\n    background: #f8f9fa;\n    transform: scale(1.1);\n  }\n}\n\n.verifyBtn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  min-width: 40px;\n  \n  &.verified {\n    background: #d5f4e6;\n    color: #27ae60;\n    \n    &:hover {\n      background: #a8e6cf;\n      transform: scale(1.05);\n    }\n  }\n  \n  &.unverified {\n    background: #fadbd8;\n    color: #e74c3c;\n    \n    &:hover {\n      background: #f1948a;\n      transform: scale(1.05);\n    }\n  }\n}\n\n.commentInput {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  \n  &:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n  }\n}\n\n.viewDetailsBtn {\n  padding: 6px 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  background: #3498db;\n  color: white;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  \n  &:hover {\n    background: #2980b9;\n    transform: scale(1.05);\n  }\n}\n\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.paginationInfo {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.itemsPerPage {\n  padding: 5px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: white;\n}\n\n.paginationControls {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n\n.pageBtn {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  \n  &:hover:not(:disabled) {\n    background: #667eea;\n    color: white;\n    border-color: #667eea;\n  }\n  \n  &.activePage {\n    background: #667eea;\n    color: white;\n    border-color: #667eea;\n  }\n  \n  &.disabled {\n    color: #ccc;\n    cursor: not-allowed;\n  }\n}\n\n.loading, .error {\n  text-align: center;\n  padding: 40px;\n  font-size: 1.2rem;\n  color: #666;\n}\n\n.error {\n  color: #e74c3c;\n}\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.verificationModal {\n  background: white;\n  border-radius: 10px;\n  padding: 30px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.verificationModal h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 1.5rem;\n}\n\n.verificationModal p {\n  margin: 0 0 20px 0;\n  color: #666;\n}\n\n.allFields, .singleField {\n  margin: 20px 0;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border-left: 4px solid #667eea;\n}\n\n.fieldRow {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid #eee;\n  \n  &:last-child {\n    border-bottom: none;\n  }\n  \n  label {\n    font-weight: 600;\n    color: #333;\n    min-width: 150px;\n  }\n  \n  span {\n    color: #666;\n    text-align: right;\n    flex: 1;\n  }\n}\n\n.singleField {\n  label {\n    display: block;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 10px;\n  }\n  \n  span {\n    display: block;\n    color: #666;\n    padding: 10px;\n    background: white;\n    border-radius: 4px;\n    border: 1px solid #ddd;\n  }\n}\n\n.verificationActions {\n  margin: 20px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.modalButtons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.closeBtn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  background: #6c757d;\n  color: white;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  \n  &:hover {\n    background: #5a6268;\n    transform: translateY(-1px);\n  }\n}\n\n.modal {\n  background: white;\n  border-radius: 10px;\n  padding: 30px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.modal h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 1.5rem;\n}\n\n.modal p {\n  margin: 0 0 20px 0;\n  color: #666;\n}\n\n.passwordInput {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 1rem;\n  margin-bottom: 15px;\n  \n  &:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n  }\n}\n\n.modalButtons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.deleteConfirmBtn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  background: #dc3545;\n  color: white;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  \n  &:hover:not(:disabled) {\n    background: #c82333;\n    transform: translateY(-1px);\n  }\n  \n  &:disabled {\n    background: #6c757d;\n    cursor: not-allowed;\n  }\n}\n\n.cancelBtn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  background: #6c757d;\n  color: white;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  \n  &:hover {\n    background: #5a6268;\n    transform: translateY(-1px);\n  }\n}\n\n// Enhanced responsive design\n@media (max-width: 1200px) {\n  .container {\n    padding: 15px;\n  }\n  \n  .header {\n    padding: 15px;\n  }\n  \n  .headerLeft h2 {\n    font-size: 1.5rem;\n  }\n  \n  .dataTable {\n    font-size: 0.8rem;\n    \n    th, td {\n      padding: 10px 6px;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 10px;\n  }\n  \n  .header {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n    padding: 15px;\n  }\n  \n  .headerLeft h2 {\n    font-size: 1.3rem;\n  }\n  \n  .headerRight {\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  \n  .refreshBtn, .printBtn, .excelBtn, .deleteBtn {\n    padding: 8px 12px;\n    font-size: 0.9rem;\n  }\n  \n  .globalSearch {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n  \n  .searchInput {\n    min-width: auto;\n    padding: 10px 12px;\n  }\n  \n  .filterToggle, .clearFilters {\n    padding: 10px 12px;\n  }\n  \n  .filtersGrid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n  \n  .filterGroup input {\n    padding: 6px 10px;\n  }\n  \n  .dataTable {\n    font-size: 0.75rem;\n    min-width: 2200px; // Slightly smaller minimum width for mobile (increased for new columns)\n    \n    th, td {\n      padding: 8px 4px;\n      min-width: 70px; // Smaller minimum width for mobile\n    }\n  }\n  \n  .pagination {\n    flex-direction: column;\n    gap: 15px;\n    padding: 15px;\n  }\n  \n  .paginationControls {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n  \n  .pageBtn {\n    padding: 6px 10px;\n    font-size: 0.9rem;\n  }\n  \n  .verificationModal {\n    width: 95%;\n    padding: 20px;\n    max-height: 90vh;\n  }\n  \n  .modal {\n    width: 95%;\n    padding: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .container {\n    padding: 5px;\n  }\n  \n  .header {\n    padding: 10px;\n  }\n  \n  .headerLeft h2 {\n    font-size: 1.2rem;\n  }\n  \n  .dataTable {\n    font-size: 0.7rem;\n    min-width: 2000px; // Increased for new depreciation columns\n    \n    th, td {\n      padding: 6px 3px;\n      min-width: 60px;\n    }\n  }\n  \n  .verifyBtn {\n    padding: 4px 8px;\n    font-size: 0.9rem;\n    min-width: 35px;\n  }\n  \n  .commentInput {\n    padding: 4px 6px;\n    font-size: 0.75rem;\n  }\n  \n  .viewDetailsBtn {\n    padding: 4px 8px;\n    font-size: 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StoreVerify_container__K47HW`,
	"header": `StoreVerify_header__un3Vm`,
	"headerLeft": `StoreVerify_headerLeft__n0IwR`,
	"headerRight": `StoreVerify_headerRight__cP+0y`,
	"refreshBtn": `StoreVerify_refreshBtn__MTF0V`,
	"printBtn": `StoreVerify_printBtn__mkmqh`,
	"excelBtn": `StoreVerify_excelBtn__Dvh0D`,
	"deleteBtn": `StoreVerify_deleteBtn__XaaH+`,
	"globalSearch": `StoreVerify_globalSearch__tpJX0`,
	"searchInput": `StoreVerify_searchInput__UyQqY`,
	"filterToggle": `StoreVerify_filterToggle__NAzFn`,
	"clearFilters": `StoreVerify_clearFilters__xqXfS`,
	"filtersPanel": `StoreVerify_filtersPanel__GDnB8`,
	"filtersGrid": `StoreVerify_filtersGrid__iS7qL`,
	"filterGroup": `StoreVerify_filterGroup__v8BhU`,
	"tableContainer": `StoreVerify_tableContainer__JA967`,
	"dataTable": `StoreVerify_dataTable__Ky2rh`,
	"mainHeader": `StoreVerify_mainHeader__JT9AO`,
	"subHeader": `StoreVerify_subHeader__J1k25`,
	"columnNumbers": `StoreVerify_columnNumbers__4RuHu`,
	"dataRow": `StoreVerify_dataRow__ABvdH`,
	"noData": `StoreVerify_noData__cHnFQ`,
	"clickableField": `StoreVerify_clickableField__MwmUA`,
	"depreciationValue": `StoreVerify_depreciationValue__W-FPO`,
	"depreciationAmount": `StoreVerify_depreciationAmount__N4PM3`,
	"depreciationInputGroup": `StoreVerify_depreciationInputGroup__sAWb3`,
	"depreciationInput": `StoreVerify_depreciationInput__cT6t5`,
	"manualIndicator": `StoreVerify_manualIndicator__Rs5JA`,
	"resetBtn": `StoreVerify_resetBtn__uyOdA`,
	"verifyBtn": `StoreVerify_verifyBtn__TWdQa`,
	"verified": `StoreVerify_verified__kExIH`,
	"unverified": `StoreVerify_unverified__-47ze`,
	"commentInput": `StoreVerify_commentInput__ohmJp`,
	"viewDetailsBtn": `StoreVerify_viewDetailsBtn__H9W-o`,
	"pagination": `StoreVerify_pagination__L0XsV`,
	"paginationInfo": `StoreVerify_paginationInfo__0zE1h`,
	"itemsPerPage": `StoreVerify_itemsPerPage__9k5M1`,
	"paginationControls": `StoreVerify_paginationControls__84Z0E`,
	"pageBtn": `StoreVerify_pageBtn__NWpnF`,
	"activePage": `StoreVerify_activePage__N1m9r`,
	"disabled": `StoreVerify_disabled__YzEO-`,
	"loading": `StoreVerify_loading__YtjWH`,
	"error": `StoreVerify_error__deRcn`,
	"modalOverlay": `StoreVerify_modalOverlay__4+yz+`,
	"verificationModal": `StoreVerify_verificationModal__KDMMS`,
	"allFields": `StoreVerify_allFields__a2P5n`,
	"singleField": `StoreVerify_singleField__Klh2i`,
	"fieldRow": `StoreVerify_fieldRow__-0iZ9`,
	"verificationActions": `StoreVerify_verificationActions__WaAO3`,
	"modalButtons": `StoreVerify_modalButtons__-79GP`,
	"closeBtn": `StoreVerify_closeBtn__WLB3S`,
	"modal": `StoreVerify_modal__3uKSA`,
	"passwordInput": `StoreVerify_passwordInput__nrkyH`,
	"deleteConfirmBtn": `StoreVerify_deleteConfirmBtn__UmlEZ`,
	"cancelBtn": `StoreVerify_cancelBtn__+x13R`
};
export default ___CSS_LOADER_EXPORT___;
